<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        カードリーダー管理 - 機器の一括登録
        <div class="headerBtn" @click="screenTransition('/cardReader')" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録準備
        </div>
        <div class="row" style="text-align: left;">
          最初に、以下のボタンより登録用のテンプレートファイルをダウンロードします。
        </div>
        <div class="row">
          <div class="edit" @click="doDownload(templateFilePath, templateFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            テンプレート
          </div>
          <div class="detail" @click="doDownload(sumpleFilePath, sumpleFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            記入サンプル
          </div>
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録用テンプレート記載方法
        </div>
        <div class="row" style="text-align: left;">
          2行目以降に機器ID、CCUS現場ID、入退場モードをカンマ区切りで記載します。<br>
          入退場モードは「入退場共用」「入場専用」「退場専用」のいずれかを記入して下さい。<br>
          空白や空行を含めますと正常に処理が終了しない可能性がございますので、加えないようお願い致します。<br>
          行の末尾にはカンマは不要です。<br>
          Excelなどで保存した場合、エラーとなる可能性がございますので、編集時には他のテキストツールをご利用下さい。
        </div>
        <div class="row">
          <img src="../assets/card-reader-bulk-sample.png">
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          <!--  アップロードアイコン設定予定 v-icon? -->
          アップロード
        </div>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="row">
            <p class="inputTitle editable">事業者</p>
            <validation-provider name="事業者" rules="required" mode="lazy">
              <div class="rowRight" slot-scope="ProviderProps">
                <div class="selectdiv">
                  <select  v-model="selectedCompanies">
                    <option value="" selected>事業者を選択</option>
                    <option v-for="business in optionCompanies"
                      v-bind:value="business.companyId">
                      {{ business.companyName }}
                    </option>
                  </select>
                </div>
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
          <div class="row" style="text-align: left;">
            カードリーダー情報を記載し保存したファイルを以下で選択し、アップロードして下さい。
          </div>
          <div class="row">
            <div style="text-align: left">
            <validation-provider name="対象のファイル" rules="required|ext:csv" mode="lazy">
              <div slot-scope="ProviderProps">
                <input type="file" ref="uploadFile" accept=".csv" @change="ProviderProps.validate($event); loadCsvFile($event)">
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
          <div class="row" style="text-align: left;">
            選択されたファイル: {{fileName}} <br>
            対応するファイル形式　.csv/最大件数1000件
          </div>
          <div class="buttonGroup">
            <button class="btn" @click="csvExtract"
            v-bind:class="{
              disabled: ObserverProps.invalid || !ObserverProps.validate || !upFile || parseFlg,
              active: !ObserverProps.invalid && ObserverProps.validate && upFile && !parseFlg
            }"
            :disabled="ObserverProps.invalid || parseFlg"
            style="width: 400px;">アップロードして確認
            </button>
          </div>
        </validation-observer>
      </div>

      <!-- ローディング -->
      <div v-if="postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>

      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>

      <div v-if="rows.length > 0 && !postLodingFlg">
        <vue-good-table
          :columns='columns'
          :rows='rows'
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
          >
          <div slot="emptystate">データがありません</div>
        </vue-good-table><div class="buttonGroup">

        <button class="btn" @click="confirm" style="width: 400px;"
        v-bind:class="{active: true}">登録</button>
        </div>
      </div>
      <div v-if="errorMessages.length > 0">
        <div　class="errMsg" v-for="error in errorMessages">
          <div class="errSpan">{{error}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider, ValidationObserver } from 'vee-validate';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T,   R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T,   R>(val: T): ChainedWhen<T,   R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T,   A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T,   A>(fn()) : chain<T,   A>(val),
});
// when使用のための処理 ------ end

export default {
  title: 'カードリーダー一括登録',
  name: 'CardReaderBulkAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    VueLoading,
  },
  // setup() {
  // return {
  // },
  // },
  data() {
    return {
      curdReaderslistPath: '/cardReader',                          // カードリーダー一覧パス
      templateFilePath: '/files/card-reader-bulk-template.csv', // テンプレートファイルパス
      templateFileName: 'card-reader-bulk-template.csv',           // テンプレートファイルダウンロード時のファイル名
      sumpleFilePath: '/files/card-reader-bulk-sample.csv',     // 記入サンプルファイルパス
      sumpleFileName: 'card-reader-bulk-sample.csv',               // 記入サンプルファイルダウンロード時のファイル名
      fileName: '',
      upFile: '',             // アップロードファイル
      csvData: {},            // ファイルから読み込んだCSVデータ
      selectedCompanies: '',  // 選択した事業者用
      optionCompanies: [],    // 選択用事業者配列
      errorMessages: [],       // エラーメッセージ配列
      columns:  [
        {
          label: '機器ID',
          field: 'deviceId',
        },
        {
          label: 'CCUS現場ID',
          field: 'ccusSiteId',
          // TODO suzuno formatFn: を置き、IDに一致する現場名を取得予定
        },
        {
          label: '事業者ID',
          field: 'companyId',
          // TODO suzuno formatFn: を置き、IDに一致する事業者名を取得予定
        },
        {
          label: '入退場モード',
          field: 'modeId',
          // TODO suzuno formatFn: を置き、IDに一致する入退場モード名を取得予定
        },
      ],
      rows: [],
      // ローディング
      getLodingFlg: false, // データ取得時ローディング用フラグ
      getErrorFlg: false, // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false, // データ登録時エラーフラグ
      parseFlg: false,
      errorMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      this.getLodingFlg = true;
      // 事業者リスト取得API呼出
      this.optionCompanies = await this.callGetCompaniesList();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 事業者リスト取得API呼び出し
    async callGetCompaniesList() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getCompaniesList();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      }
    },
    // アップロードファイル取得
    loadCsvFile(event) {
      this.fileName = event.target.files[0].name;
      this.upFile = event.target.files[0];
      this.$refs.uploadFile.value = null;
      this.parseFlg = false;
    },
    // アップロードして確認ボタン押下時
    async csvExtract() {
      const errorMessages = new Array();
      let flg = false;
      try {
        // 抽出CSV配列とエラーメッセージ配列を空にする
        this.csvData.length = 0;
        if (!this.upFile) {
          errorMessages.push('ファイルを選択して下さい');
          return;
        }
        // 取り込んだCSVファイルをオブジェクト配列に変換
        this.$papa.parse(this.upFile, {
          encoding: 'Shift-JIS',
          header: true,
          complete: this.csvGet,
          error: function(err, file) {
            errorMessages.push('CSVの抽出に失敗しました。ファイルを再度選択して下さい');
            flg = true;
          }
        });
      } catch (error) {
        errorMessages.push('CSVの抽出に失敗しました。ファイル内のデータをご確認下さい');
      } finally {
        this.errorMessages = errorMessages;
        new Promise<void>((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1);
        }).then(() => {
          this.parseFlg = flg;
          this.scrollBottom();
        });
      }
    },
    // CSVから抽出されたオブジェクト配列を加工
    async csvGet(results) {
      try {
        const errorMessages = new Array();
        // 事業者ID　completeの中では参照できないためローカルの変数に移す
        const selectedCompanies = this.selectedCompanies;
        const restResourceService = new ApiClient();
        this.csvData = results.data;
        if(this.csvData.length === 0) {
          errorMessages.push('登録データが存在しません。ファイル内のデータをご確認下さい');
        }
        for (let i = 0; i < this.csvData.length;  i++) {
          // 選択した事業者の事業者IDをプロパティとして追加
          this.csvData[i].companyId = selectedCompanies;
          // 必要情報が欠けた行が存在した場合、エラーメッセージを詰める

          let _deviceId = common.trimSpace(this.csvData[i].deviceId);
          await validate(_deviceId, 'required|deviceId:_deviceId|max:20', {
            name: '機器ID（deviceId）',
            values: {
              _deviceId
            }
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          let ccusSiteId = common.trimSpace(this.csvData[i].ccusSiteId);
          await validate(ccusSiteId, 'required|digits:14', {
            name: 'CCUS現場ID（ccusSiteId）',
            values: {
              ccusSiteId
            }
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          let mode = common.trimSpace(this.csvData[i].mode);
          await validate(mode, 'required', {
            name: '入退場モード（mode）',
            values: {
              mode
            }
          }).then((result) => {
            if (!result.valid) {
              errorMessages.push((i + 1) + '行目' + result.errors[0]);
            }
          });

          // TODO suzuno 現場IDの存在チェック
          // const siteIdCheck = await restResourceService.getSite(this.csvData[i].ccusSiteId);
          // if (siteIdCheck) {
          // this.errorMessages.push(i + '行目 存在しないccusSiteIdです。');
          // break;
          // }

          // TODO suzuno 入退場モードリストをDBから取得して変換する
          when(this.csvData[i].mode)
            .on((v) => v === '入退場共用', () => this.csvData[i].modeId = '8cf6ed77-0703-cbc2-fbc0-1ed9234c8b3c')
            .on((v) => v === '入場専用', () => this.csvData[i].modeId = 'd0ba89f1-2b26-1efd-cca4-a542cf909756')
            .on((v) => v === '退場専用', () => this.csvData[i].modeId = '0b668acc-ebb8-674c-fd52-5c3f910bd841');

          // TODO suzuno 入退場モードリストをDBから取得してnameをエラーメッセージに詰める
          if (!this.csvData[i].modeId) {
            errorMessages.push((i + 1) + '行目 modeには「入退場共用」「入場専用」「退場専用」のいずれかを入力して下さい');
          }
          // 日本語部分の入退場フィールドは不要なため、削除
          delete this.csvData[i].mode;
        }
        // エラーメッセージが詰められていた場合、処理を中断する
        if (errorMessages.length !== 0) {
          this.errorMessages = errorMessages;
          this.scrollBottom();
          return;
        }
        this.rows = this.csvData;
        this.scrollBottom();
      } catch (error){
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      }
    },
    // DOM更新待機後スクロール
    async scrollBottom() {
      await this.$nextTick();
      common.scrollBottom();
    },
    // 登録ボタン押下時処理
    async confirm() {
      try {
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        // カードリーダー一括登録API呼出
        const restResourceService = new ApiClient();
        // 一括登録実行
        await restResourceService.postCardReader(this.csvData);
        // カードリーダー一覧画面に戻る
        this.screenTransition(this.curdReaderslistPath);
      } catch (error) {
        this.errorMessage = error.message;
        this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
        await this.$nextTick();
        common.scrollBottom();
      }
    },
    // ダウンロード処理（ファイルパス, DL時ファイル名）
    doDownload(url, filename) {
      common.doDownload(url, filename);
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

/*** iOS ***/
.switch__label {
	width: 100px;
	position: relative;
	display: inline-block;
  margin-top: 13px;
}
.switch__content {
	display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
overflow: hidden;
}
.switch__content:before {
	content: "";
	display: block;
	position: absolute;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	top: 0;
	left: 0;
	border: 1.5px solid #E5E5EA;
	border-radius: 130px;
	background-color: #fff;
}
.switch__content:after {
	content: "";
	display: block;
	position: absolute;
	background-color: transparent;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	border-radius: 30px;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input {
	display: none;
}

.switch__circle {
	display: block;
	top: 2px;
	left: 2px;
	position: absolute;
	-webkit-box-shadow: 0 2px 6px #999;
	        box-shadow: 0 2px 6px #999;
	width: 27px;
	height: 27px;
	-webkit-border-radius: 20px;
	        border-radius: 20px;
	background-color: #fff;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input:checked ~ .switch__circle {
	left: 71px;
}

.switch__input:checked ~ .switch__content:after {
	background-color: #4BD964;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}
</style>
